<!-- The viewport clips and receives every pointer/wheel/drop event. The artboard
     inside it carries the pan/zoom transform, so nothing else has to know about
     the viewport transform. -->
<div
  #viewportEl
  class="dsg-viewport"
  [ngStyle]="workspaceStyles()"
  [class.is-pan]="isPanMode()"
  [class.is-preview]="preview()"
  (wheel)="onWheel($event)"
  (pointerdown)="onCanvasPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerUp($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <!-- Coordinate space only — the grid and workspace colour live on the
       viewport above, and the white page is the Screen frame itself. -->
  <div class="dsg-artboard" [ngStyle]="artboardStyles()">
    <app-design-node-view
      *ngFor="let node of nodes(); trackBy: trackById"
      [node]="node"
      [siblings]="nodes()"
      [selectedIds]="selectedIds()"
      [dropTargetId]="dropTargetId()"
      [suspended]="suspended()"
      [hideSample]="hideSample()"
      [editingTextId]="editingTextId()"
      (nodePointerDown)="onNodePointerDown($event)"
      (nodeDoubleClick)="onNodeDoubleClick($event)"
      (textCommit)="onTextCommit($event)"
    ></app-design-node-view>
  </div>

  <!-- Overlay layer — screen space, so handles and guides keep a constant size
       at every zoom level. -->
  <div class="dsg-overlay" *ngIf="!preview()">
    <!-- Layout grid — over each Screen frame only, above its widgets. -->
    <div
      *ngFor="let grid of layoutGrids(); trackBy: trackById"
      class="dsg-layout-grid"
      [ngStyle]="grid.styles"
    ></div>

    <!-- Where the published page stops being visible without scrolling. -->
    <!-- Page edges: always visible, whatever the page's fill or the zoom. -->
    <div *ngFor="let outline of frameOutlines(); trackBy: trackById" class="dsg-frame-outline" [ngStyle]="outline.styles"></div>
    <div *ngFor="let fold of foldLines(); trackBy: trackById" class="dsg-fold" [ngStyle]="fold.styles">
      <span class="dsg-fold-label">{{ fold.label }}</span>
    </div>

    <!-- Snap guides. -->
    <div
      *ngFor="let guide of guides()"
      class="dsg-guide"
      [class.is-vertical]="guide.axis === 'x'"
      [ngStyle]="guideStyles(guide)"
    ></div>

    <!-- Marquee / draw rectangle. -->
    <div class="dsg-marquee" [ngStyle]="marqueeStyles()"></div>

    <app-design-selection-box
      *ngIf="selectionBounds() as bounds"
      [bounds]="bounds"
      [viewport]="viewport()"
      [multiple]="multiSelect()"
      [selectionCount]="selectedIds().size"
      [grouped]="selectedIsGroup()"
      [fixed]="selectedIsScreen()"
      [interacting]="interacting()"
      [rotation]="selectionRotation()"
      (resizeStart)="onResizeStart($event)"
      (rotateStart)="onRotateStart($event)"
      (groupRequested)="groupSelection()"
    ></app-design-selection-box>
  </div>
</div>
